export const formatTransactionType = (value: string | null | undefined): string => {
  if (!value) return '—';

  return value
    .replace(/_/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .trim();
};
